<template>
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 19.675C15.4183 19.675 19 16.0933 19 11.675C19 7.25677 15.4183 3.67505 11 3.67505C6.58172 3.67505 3 7.25677 3 11.675C3 16.0933 6.58172 19.675 11 19.675Z" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.0004 21.675L16.6504 17.325" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
